<form [formGroup]="negotiationForm">
    <div class="container" *ngIf="!isCategoryTypeLoading && !isNegotiationTypeLoading">
        <div class="title-container">
            <h2 class="mat-title">{{ !data.isDuplication ? "Ajout d'une négociation" : "Duplication d'une négociation" }}</h2>
        </div>

        <div class="tv-ns-custom-horizontal-divider"></div>
        <div class="bloc-container">
            <h4 class="red-title">Général</h4>
            <div class="inputs-container">
                <!-- Negotiation Type -->
                <div class="tv-rect-input-extensible flex-auto">
                    <mat-form-field>
                        <mat-label>Type de négotiation</mat-label>
                        <input
                            class="tv-ns-select-option"
                            type="text"
                            matInput
                            [formControl]="negotiationTypeFormControl"
                            [matAutocomplete]="auto" />
                        <mat-autocomplete
                            autoActiveFirstOption
                            class="tv-custom-always-visible-scroll-bar"
                            #auto="matAutocomplete"
                            [displayWith]="displayNegotiationType">
                            <mat-option
                                *ngFor="let negotiationType of filteredNegotiationTypeList | async"
                                class="tv-ns-select-option"
                                [value]="negotiationType">
                                {{ negotiationType.id }} - {{ negotiationType.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <div
                        class="tv-input-error-message"
                        *ngIf="negotiationTypeFormControl.touched && negotiationTypeFormControl.hasError('required')">
                        <mat-icon class="tv-input-error-icon">error</mat-icon>
                        <span class="tv-input-error-text">Veuillez choisir un type de négociation</span>
                    </div>
                </div>

                <!-- Date Range -->
                <app-date-range-picker
                    [screenFilterForm]="negotiationForm"
                    [paramStartDate]="negotiationForm.get('startDate').value"
                    [paramEndDate]="negotiationForm.get('endDate').value"
                    [isRestrictedToParamDates]="true"
                    [styleType]="'squared'">
                </app-date-range-picker>

                <!-- Rate  -->
                <div>
                    <div class="rate">
                        <button class="tv-chip-icon-rate-button-medium-light-blue">
                            <mat-chip-listbox class="tv-container-rate-chip-set-button">
                                <mat-chip-option
                                    *ngFor="let view of displayViews"
                                    (click)="selectedDisplayView(view)"
                                    [selected]="this.selectedView === view?.id">
                                    {{ view.display }}
                                </mat-chip-option>
                            </mat-chip-listbox>
                        </button>
                        <div class="tv-rect-input-extensible">
                            <mat-form-field>
                                <mat-label>Montant de la remise</mat-label>
                                <input type="number" matInput [formControl]="rateFormControl" (blur)="enforceNegativeRate()" />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="tv-input-error-message" *ngIf="rateFormControl.touched && rateFormControl.hasError('required')">
                        <mat-icon class="tv-input-error-icon">error</mat-icon>
                        <span class="tv-input-error-text">Veuillez saisir un taux ou une valeur</span>
                    </div>
                    <div class="tv-input-error-message" *ngIf="rateFormControl.touched && rateFormControl.hasError('maxRateExceeded')">
                        <mat-icon class="tv-input-error-icon">error</mat-icon>
                        <span class="tv-input-error-text">Valeur comprise entre -999 et 999</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Conditions Template -->
        <div class="cond-container">
            <ng-template #dynamicConditionComponent></ng-template>
        </div>

        <!-- Add Conditions-->
        <div class="add-category-bloc-container">
            <span>Conditions</span>
            <div>
                <mat-icon class="type-icon" svgIcon="add-circle-fill" (click)="createDynamicConditionComponent(1, 'Inclus')"> </mat-icon>
                <!--                <mat-icon-->
                <!--                        class="type-icon"-->
                <!--                        svgIcon="delete-circle-fill"-->
                <!--                        (click)="createDynamicConditionComponent(0, 'Exclus')"-->
                <!--                >-->
                <!--                </mat-icon>-->
            </div>
        </div>

        <div class="button-edit">
            <button class="tv-ns-secondary-large-button-on-light-bg" (click)="onCancelUpdateButtonClick()">Annuler</button>
            <button type="submit" class="tv-ns-validation-large-button" (click)="onValidationButtonClick()">Valider</button>
        </div>
    </div>
</form>
